import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { createBrowserHistory } from "history";

import Login from "../containers/LoginContainer";
import Signup from "../containers/SignupContainer";
import DefaultLayout from "../containers/DefaultLayout";
import ProfileUpdate from "../containers/ProfileUpdateContainer";
import Forgotpassword from "../containers/ForgottPasswordContainer";
import PromtMsg from "../containers/PromptMsgContainer";
var history = createBrowserHistory();

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("userdata") ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

function AppNavigator() {
  return (
    <Switch>
      <Route
        path="/forgotpassword"
        name="Forgotpaasword"
        component={Forgotpassword}
      />
      <Route path="/login" name="Login" component={Login} />, 
      <Route path="/signup" name="Signup" component={Signup} />,
      <Route path="/promptMsg" name="PromtMsg" component={PromtMsg} />,
      <Route
        path="/profileupdate"
        name="ProfileUpdate"
        component={ProfileUpdate}
      />
      ,
      <Route path="/dashboard" name="Dashboard" component={DefaultLayout} />,
      <Route path="/" name="Dashboard" component={DefaultLayout} />
    </Switch>
  );
}
export default AppNavigator;
